import { RouteObject } from "react-router-dom";
import Loadable from "@/components/Loadable";
import { lazy } from "react";

const ErrorPage = Loadable(lazy(() => import("@/containers/pages/NotFound")));
const ErrorPermissionPage = Loadable(lazy(() => import("@/containers/pages/NotPermission")));

const MainRoutes: Array<RouteObject> = [
  {
    path: "/permission_failed",
    element: (
      <ErrorPermissionPage />
    ),
  },
  {
    path: "*",
    element: (
      <ErrorPage />
    ),
  },
];

export default MainRoutes;
